import { render, staticRenderFns } from "./dataClassification_index.vue?vue&type=template&id=24550419&scoped=true"
import script from "./dataClassification_index.vue?vue&type=script&lang=js"
export * from "./dataClassification_index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24550419",
  null
  
)

export default component.exports